import { render, staticRenderFns } from "./AppSignupTopPage.vue?vue&type=template&id=cc1dd8f0"
import script from "./AppSignupTopPage.vue?vue&type=script&lang=ts"
export * from "./AppSignupTopPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports